import { useState } from 'react';
import { oneLbInKg } from '../../constants/constant.js';
import { calculator } from '../../functions/calculator';
import Actions from './Actions';
import Powered from './Powered';
import Share from './Share';
import Switcher from './Switcher';
function valuetext(value) {
  return `${value}`;
}

const Home = () => {
  let [weight, setWeight] = useState(150 / 2);
  let [prefer, setPrefer] = useState('');
  let [showResult, setShow] = useState(false);
  let [results, setResult] = useState({});
  let [showGetter, _setGetter] = useState(false);
  let [btn, setBtn] = useState(true);

  const setGetter = (showGetter) => {
    _setGetter(showGetter);
    if (showGetter) {
      setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 200);
    }
  };

  const handleWeightChange = (e) => {
    const value = e.target.value;
    setWeight(value);
  };
  const resetForm = () => {
    setWeight(150 / 2);
    setPrefer('');
  };

  const handleWeightClick = (e) => {
    setBtn(!btn);
    e.target.setAttribute('disabled', 'disabled');
    switch (btn) {
      case true:
        if (btn) {
          setWeight(Math.round(weight * oneLbInKg));
        } else {
          setWeight(Math.round(weight / oneLbInKg));
        }

        break;
      case false:
        if (btn) {
          setWeight(Math.round(weight * oneLbInKg));
        } else {
          setWeight(Math.round(weight / oneLbInKg));
        }

        break;
      default:
    }
  };
  const preferChoose = (userPreference) => {
    setPrefer(userPreference);
  };

  const calculate = (e) => {
    setResult(calculator(weight, prefer, btn));
    e.target.classList.add('is-loading', 'btn');
    setTimeout(() => {
      setShow(true);
    }, 100);
  };
  const goBack = () => {
    setShow(false);
  };

  return (
    <div className="Main">
      <Switcher
        showResult={showResult}
        results={results}
        weight={weight}
        prefer={prefer}
        goBack={goBack}
        resetForm={resetForm}
        btn={btn}
        handleWeightChange={handleWeightChange}
        valuetext={valuetext}
        handleWeightClick={handleWeightClick}
        preferChoose={preferChoose}
      />
      <Powered />
      <Actions
        showResult={showResult}
        calculate={calculate}
        resetForm={resetForm}
        prefer={prefer}
      />
      <Share setGetter={setGetter} showGetter={showGetter} />
    </div>
  );
};

export default Home;
